import {EventEmitter, Injectable, Output} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable()
export class SharedDashboardSvc {
    @Output() public change: EventEmitter<boolean> = new EventEmitter<boolean>();
    public acceptDisclaimerModel: Subject<boolean> = new Subject<boolean>();

    public toggle() {
        this.change.emit(true);
    }

    public disclaimerAccepted() {
      this.acceptDisclaimerModel.next(true);
    }
}
